var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M373.156 401.594C389.937 422.125 386.906 452.374 366.39 469.156C357.484 476.437 346.718 479.999 336.031 479.999C322.125 479.999 308.344 473.999 298.844 462.406L192 331.821L85.156 462.406C75.656 473.999 61.875 479.999 47.969 479.999C37.282 479.999 26.532 476.437 17.61 469.156C-2.906 452.374 -5.937 422.125 10.844 401.594L129.967 256.001L10.844 110.408C-5.937 89.877 -2.906 59.627 17.61 42.846C38.094 26.065 68.36 29.096 85.156 49.596L192 180.181L298.844 49.596C315.64 29.096 345.875 26.065 366.39 42.846S389.937 89.877 373.156 110.408L254.033 256.001L373.156 401.594Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ce030e494bd65ae3104a30a8b5bd613a.svg";
export { ForwardRef as ReactComponent };